// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__2F0Jp","gradient":"Home_gradient__11nYM","icon":"Home_icon__1gK9S","fas":"Home_fas__3hnYi"};